import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#6DA544\" d=\"M12-.001c-2.122 0-4.114.551-5.844 1.517v20.966A11.94 11.94 0 0 0 12 23.999c6.627 0 12-5.373 12-12s-5.373-12-12-12\"></path><path fill=\"#F0F0F0\" d=\"M6.194 1.498A12 12 0 0 0 4.287 2.81l9.19 9.19-9.19 9.191a12 12 0 0 1 1.907 1.312L24.002 12z\"></path><path fill=\"#FFDA44\" d=\"M5.177 2.127q-.55.38-1.052.817L12 12l-7.874 9.055q.503.437 1.052.817L21.945 12z\"></path><path fill=\"#000\" d=\"M4.286 2.81q-.4.336-.77.705L10.958 12l-7.442 8.486q.37.368.77.705l9.19-9.19z\"></path><path fill=\"#D80027\" d=\"M3.515 3.514c-4.687 4.686-4.687 12.285 0 16.97L12 12z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }